import React, { useEffect, useState } from 'react'
import { Box, Button, FormControl, Modal, TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { selectShowManagerNotesModal, selectSingleWorkout, setEditFlag, setShowManagerNotesModal, UpdateParticipantInfoAsync } from '../features/add_workout/workoutSlice';
import { editModalStyle, participant } from '../app/consts';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const ShowManagerNotes = () => {
    const workoutId = useParams().workoutId;
    const uniqueId = useParams().uniqueId;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const showManagerNotesModal = useAppSelector(selectShowManagerNotesModal);
    const currentWorkout = useAppSelector(selectSingleWorkout);
    const [note, setNote] = useState("")

    useEffect(() => {
        dispatch(setShowManagerNotesModal(true))
        // eslint-disable-next-line
    }, [])
    const currentParticipant = currentWorkout?.participantsList?.find((item) => item.uniqueId === uniqueId);

    const handleAddManagerNote = () => {
        let updatedData = { ...currentParticipant, adminNotes: [...(currentParticipant?.adminNotes || [])] } as participant;
        if (note.trim() !== "")
            updatedData.adminNotes?.push({ id: updatedData.adminNotes?.length as number + 1, content: note })
        else {
            toast.error("נא להזין הערה");
            return
        }

        dispatch(UpdateParticipantInfoAsync({ workoutId: Number(workoutId), participantUniqueId: updatedData.uniqueId as string, updatedData: updatedData }))
        .catch(()=>{
            toast.error("אירעה שגיאה");
        })
        .then(() => {
            dispatch(setEditFlag())
            toast.success("ההערה נשמרה בהצלחה")            
        })
    }

    const handleRemoveManagerNote = (noteId: number) => {
        let updatedData = { ...currentParticipant, adminNotes: [...(currentParticipant?.adminNotes || [])] } as participant;
        const index = updatedData.adminNotes?.findIndex(item => item.id === noteId) as number;
        updatedData.adminNotes?.splice(index, 1)
        dispatch(UpdateParticipantInfoAsync({ workoutId: Number(workoutId), participantUniqueId: updatedData.uniqueId as string, updatedData: updatedData }))
        .catch(()=>{
            toast.error("אירעה שגיאה");
        })
        .then(() => {
            dispatch(setEditFlag())
            toast.success("ההערה נמחקה בהצלחה")            
        })
    }

    return (
        <Modal open={showManagerNotesModal} onClose={() => { dispatch(setShowManagerNotesModal(false)); navigate(`/manageWorkout/participants/${workoutId}`) }}>
            <Box sx={editModalStyle}>
                <p style={{ fontSize: '20px', fontWeight: 'bold' }} onClick={() => { dispatch(setShowManagerNotesModal(false)); navigate(`/manageWorkout/participants/${workoutId}`) }}>X</p>
                {currentParticipant === undefined ?
                    <img src='/FadingCircles.gif' alt='spinner' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
                    :
                    <>
                        <h3>הערות מנהל עבור המתאמן:<br />{currentParticipant?.firstName} {currentParticipant?.lastName}</h3>
                        {currentParticipant?.adminNotes?.map((note, index) =>
                            <div key={index}>
                                <Button onClick={() => handleRemoveManagerNote(note.id)}>🗑</Button>
                                {note.content}
                            </div>)}
                        <br />
                        <form method='POST' id='notesForm' onSubmit={(e) => e.preventDefault()}>
                            <FormControl>
                                <TextField variant="filled" label='הערות' type='text' value={note} onChange={(e) => setNote(e.target.value)} style={{ textAlign: 'center', width: '300px', }} slotProps={{ htmlInput:{ pattern: ".+" } }} />
                                <br /><br/><br /><br/>
                                <Button id='submit' type='submit' onClick={() => {
                                    handleAddManagerNote();
                                    setNote("")
                                }}
                                    variant="contained" size='large' color='success'>הוסף הערה</Button>
                            </FormControl>
                        </form>
                    </>
                }
            </Box>
        </Modal>
    )
}

export default ShowManagerNotes